import React from "react";
import { MapPin, Building, User, Eye } from "lucide-react";
import StatusBadge from "./StatusBadge";
import { Card } from "../../components/AdminSharedComponents";

// ===============================
// CONSTANTS
// ===============================
const PROJECT_INFO_ITEMS = [
  {
    key: "location",
    icon: MapPin,
    getValue: (project) => project.location || "No location",
    condition: () => true,
  },
  {
    key: "client_name",
    icon: Building,
    getValue: (project) => project.client_name,
    condition: (project) => !!project.client_name,
  },
  {
    key: "pic",
    icon: User,
    getValue: (project) => project.pic,
    condition: (project) => !!project.pic,
  },
];

// ===============================
// COMPONENT
// ===============================
const ProjectCard = ({ project, onSelect, formatDate }) => {
  const handleClick = () => onSelect(project);

  return (
    <Card
      className="!p-4 cursor-pointer transition-all hover:shadow-md hover:ring-2 hover:ring-primary/20"
      onClick={handleClick}
    >
      {/* Header */}
      <div className="flex items-start justify-between gap-2 mb-2">
        <h3 className="font-semibold text-base text-gray-900 line-clamp-1">
          {project.name}
        </h3>
        <StatusBadge status={project.status} />
      </div>

      {/* Project Info */}
      <div className="space-y-2 text-sm text-gray-600">
        {PROJECT_INFO_ITEMS.map(({ key, icon: Icon, getValue, condition }) =>
          condition(project) ? (
            <div key={key} className="flex items-center gap-2">
              <Icon className="h-4 w-4 text-gray-400 flex-shrink-0" />
              <span className="truncate">{getValue(project)}</span>
            </div>
          ) : null
        )}
      </div>

      {/* Footer */}
      <div className="flex items-center justify-between mt-4 pt-2 border-t border-gray-100">
        <span className="text-xs text-gray-500">
          {formatDate(project.created_at)}
        </span>
        <div className="text-sm text-primary hover:text-primary-dark transition-colors flex items-center gap-1">
          <Eye className="h-4 w-4" />
          View
        </div>
      </div>
    </Card>
  );
};

export default ProjectCard;
